import * as angular from "angular";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {SelfPickupsAlerts} from "./self-pickups-alerts.service";
import {SelfPickupsRequests} from "./self-pickups-requests.service";

export class SelfPickupsService {

  /* @ngInject */
  constructor(private selfPickupsRequests: SelfPickupsRequests, private selfPickupsAlerts: SelfPickupsAlerts, private $q: IQService,
              private bringozLoaderService: BringozLoaderService, private $log) {
  }

  createOne(selfPickup) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.selfPickupsRequests.createOne(selfPickup)
      .then((createdSelfPickup) => {
        this.selfPickupsAlerts.createOneSuccess();
        deferred.resolve(createdSelfPickup)
      })
      .catch((error) => {
        this.$log.error(error);
        this.selfPickupsAlerts.createOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateOne(id, selfPickup, ignoreToast?: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.selfPickupsRequests.updateOne(id, selfPickup)
      .then((updatedSelfPickup) => {
        if (!ignoreToast) {
          this.selfPickupsAlerts.updateOneSuccess();
        }
        deferred.resolve(updatedSelfPickup)
      })
      .catch((error) => {
        this.$log.error(error);
        this.selfPickupsAlerts.updateOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteOne(id) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.selfPickupsRequests.deleteOne(id)
      .then((deletedSelfPickup) => {
        this.selfPickupsAlerts.deleteOneSuccess();
        deferred.resolve(deletedSelfPickup)
      })
      .catch((error) => {
        this.$log.error(error);
        this.selfPickupsAlerts.deleteOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  sendMessage(id) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.selfPickupsRequests.sendMessage(id)
      .then((updatedSelfPickup) => {
        this.selfPickupsAlerts.sendMessageSuccess(id);
        deferred.resolve(updatedSelfPickup)
      })
      .catch((error) => {
        this.$log.error(error);
        this.selfPickupsAlerts.sendMessageError(id);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getTotals(depotId?, from?, to?) {
    const deferred = this.$q.defer();

    this.selfPickupsRequests.getTotals(depotId, from, to)
      .then((totals) => {
        deferred.resolve(totals)
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })

    return deferred.promise
  }

  getTimelineLogRef(id, limit) {
    const SelfPickupsRequestsRef = this.selfPickupsRequests;
    return {
      _cursor: undefined,
      $next: function () {
        const self = this;
        return SelfPickupsRequestsRef.getTimelineLog(id, limit, self._cursor)
          .then((response) => {
            self._cursor = response.cursor;
            return response.list;
          });
      },
    }
  }
}

angular
  .module('bringoz.admin.self-pickups')
  .service('selfPickupsService', SelfPickupsService);
